var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"my-96 lg:my-72"},[_c('img',{staticClass:"w-full lg:w-1/3 mx-auto object-cover",attrs:{"src":"/Digilux_Stacked.png"}})])}]

export { render, staticRenderFns }